import type { ReactNode } from 'react';
import { Provider as TooltipProvider } from '@radix-ui/react-tooltip';
import { createContext, useContext } from 'react';
import { GlobalStyle } from '../../css/GlobalStyle';
import { AriaLiveProvider } from '../AriaLiveProvider';
import { ToastProvider } from './ToastProvider';

const UIProviderNestingContext = createContext<boolean>(false);

export type UIProviderProps = {
  children: ReactNode;
};

export const UIProvider = ({ children }: UIProviderProps) => {
  const isNested = useContext(UIProviderNestingContext);

  // we don't want to have nested UIProviders so if we are already nested, just return children
  if (isNested) {
    return <>{children}</>; // eslint-disable-line react/jsx-no-useless-fragment
  }

  return (
    <UIProviderNestingContext.Provider value={true}>
      <AriaLiveProvider>
        <TooltipProvider>
          <GlobalStyle />
          {children}
          <ToastProvider />
        </TooltipProvider>
      </AriaLiveProvider>
    </UIProviderNestingContext.Provider>
  );
};
